import { useContext, useMemo } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Toaster } from "react-hot-toast";
import { MyContext } from "./Context/MyContext";
import Navbar from "./pages/Navbar";
import ScrollToTop from "./pages/ScrollToTop";
import Home from "./pages/Home/Home";
import AboutPage from "./pages/About/AboutPage";
import ServicesIndex from "./pages/Services/ServicesIndex";
import ServicePage from "./pages/Services/ServicePage";
import NotFoundPage from "./pages/NotFound/NotFoundPage";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import "./App.css";

function App() {
  const { theme } = useContext(MyContext);

  const muiTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: theme,
          primary: {
            main: theme === "dark" ? "#3aa0ff" : "#148af8",
          },
          background: {
            default: theme === "dark" ? "#070b14" : "#F7F9FC",
            paper: theme === "dark" ? "#121a28" : "#FFFFFF",
          },
          text: {
            primary: theme === "dark" ? "#F4F7FB" : "#0B1220",
            secondary: theme === "dark" ? "#9AA8BC" : "#3D4A5C",
          },
        },
        typography: {
          fontFamily: "Manrope, sans-serif",
        },
        shape: {
          borderRadius: 4,
        },
      }),
    [theme]
  );

  return (
    <Router>
      <div className="App">
        <ThemeProvider theme={muiTheme}>
          <CssBaseline />
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </ThemeProvider>
      </div>
      <Toaster position="top-center" reverseOrder={false} />
    </Router>
  );
}

export default App;
